import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { 
    Play, 
    X, 
    ChevronLeft, 
    ChevronRight, 
    Heart,
    Share2,
    Sparkles,
    Zap,
    Award
} from 'lucide-react';

function ProductosNuevos() {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [favoritos, setFavoritos] = useState([]);
    const [filtroCategoria, setFiltroCategoria] = useState('todos');

    // Datos de productos nuevos
    const productos = [
        {
            id: 1,
            nombre: "Taladro Inalámbrico Pro 20V",
            marca: "TRUPER",
            categoria: "herramientas",
            precio: "Bs. 450",
            descripcion: "Taladro inalámbrico de alta velocidad con batería de 20V",
            destacado: true,
            imagenes: [
                "https://via.placeholder.com/400x300?text=Taladro+1",
                "https://via.placeholder.com/400x300?text=Taladro+2",
                "https://via.placeholder.com/400x300?text=Taladro+3"
            ],
            videos: [
                {
                    titulo: "Demo del Taladro",
                    url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
                },
                {
                    titulo: "Especificaciones",
                    url: "https://www.youtube.com/embed/jNQXAC9IVRw"
                }
            ],
            caracteristicas: [
                "20V de potencia",
                "2 velocidades",
                "Batería Li-Ion incluida",
                "Luz LED"
            ],
            nuevo: true,
            descuento: "10%"
        },
        {
            id: 2,
            nombre: "Sierra Circular Profesional",
            marca: "FOSET",
            categoria: "herramientas",
            precio: "Bs. 580",
            descripcion: "Sierra circular de 7.25\" para cortes precisos",
            destacado: false,
            imagenes: [
                "https://via.placeholder.com/400x300?text=Sierra+1",
                "https://via.placeholder.com/400x300?text=Sierra+2"
            ],
            videos: [
                {
                    titulo: "Demostración de Corte",
                    url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
                }
            ],
            caracteristicas: [
                "7.25\" blade",
                "5800 RPM",
                "Corte limpio"
            ],
            nuevo: true,
            descuento: "15%"
        },
        {
            id: 3,
            nombre: "Conjunto de Brocas 50 piezas",
            marca: "HERMEX",
            categoria: "accesorios",
            precio: "Bs. 180",
            descripcion: "Set completo de brocas en estuche organizador",
            destacado: true,
            imagenes: [
                "https://via.placeholder.com/400x300?text=Brocas+1",
                "https://via.placeholder.com/400x300?text=Brocas+2",
                "https://via.placeholder.com/400x300?text=Brocas+3",
                "https://via.placeholder.com/400x300?text=Brocas+4"
            ],
            videos: [
                {
                    titulo: "Contenido del Set",
                    url: "https://www.youtube.com/embed/jNQXAC9IVRw"
                }
            ],
            caracteristicas: [
                "50 brocas diferentes",
                "Estuche resistente",
                "Acero de alta calidad"
            ],
            nuevo: true,
            descuento: "20%"
        },
        {
            id: 4,
            nombre: "Destornillador Set Magnético",
            marca: "PRETUL",
            categoria: "herramientas",
            precio: "Bs. 120",
            descripcion: "Set de destornilladores con tecnología magnética",
            destacado: false,
            imagenes: [
                "https://via.placeholder.com/400x300?text=Destornillador+1",
                "https://via.placeholder.com/400x300?text=Destornillador+2"
            ],
            videos: [],
            caracteristicas: [
                "Magnéticos",
                "10 piezas",
                "Mango ergonómico"
            ],
            nuevo: true,
            descuento: "5%"
        },
        {
            id: 5,
            nombre: "Lámpara LED de Taller 100W",
            marca: "VOLTECK",
            categoria: "iluminacion",
            precio: "Bs. 350",
            descripcion: "Lámpara LED de alta potencia para talleres",
            destacado: true,
            imagenes: [
                "https://via.placeholder.com/400x300?text=Lampara+1",
                "https://via.placeholder.com/400x300?text=Lampara+2",
                "https://via.placeholder.com/400x300?text=Lampara+3"
            ],
            videos: [
                {
                    titulo: "Demostración de Luz",
                    url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
                }
            ],
            caracteristicas: [
                "100W potencia",
                "6500K color",
                "Muy eficiente",
                "Larga duración"
            ],
            nuevo: true,
            descuento: "12%"
        },
        {
            id: 6,
            nombre: "Maletín Herramientas Profesional",
            marca: "FIERO",
            categoria: "almacenamiento",
            precio: "Bs. 280",
            descripcion: "Maletín resistente para almacenar herramientas",
            destacado: false,
            imagenes: [
                "https://via.placeholder.com/400x300?text=Maletin+1",
                "https://via.placeholder.com/400x300?text=Maletin+2",
                "https://via.placeholder.com/400x300?text=Maletin+3"
            ],
            videos: [
                {
                    titulo: "Interior del Maletín",
                    url: "https://www.youtube.com/embed/jNQXAC9IVRw"
                }
            ],
            caracteristicas: [
                "Material ABS",
                "Compartimientos",
                "Cerradura de seguridad"
            ],
            nuevo: true,
            descuento: "8%"
        }
    ];

    const categorias = [
        { id: 'todos', nombre: 'Todos' },
        { id: 'herramientas', nombre: 'Herramientas' },
        { id: 'accesorios', nombre: 'Accesorios' },
        { id: 'iluminacion', nombre: 'Iluminación' },
        { id: 'almacenamiento', nombre: 'Almacenamiento' }
    ];

    // Filtrar productos
    const productosFiltrados = filtroCategoria === 'todos' 
        ? productos 
        : productos.filter(p => p.categoria === filtroCategoria);

    // Manejar click en producto
    const handleProductClick = (producto) => {
        setSelectedProduct(producto);
        setCurrentImageIndex(0);
        setShowModal(true);
    };

    // Agregar/remover de favoritos
    const toggleFavorito = (id) => {
        setFavoritos(prev => 
            prev.includes(id) 
                ? prev.filter(fav => fav !== id)
                : [...prev, id]
        );
    };

    // Navegar imágenes
    const nextImage = () => {
        if (selectedProduct) {
            setCurrentImageIndex((prev) => 
                (prev + 1) % selectedProduct.imagenes.length
            );
        }
    };

    const prevImage = () => {
        if (selectedProduct) {
            setCurrentImageIndex((prev) => 
                prev === 0 ? selectedProduct.imagenes.length - 1 : prev - 1
            );
        }
    };

    return (
        <section className="productos-nuevos-section">
            {/* Fondo decorativo */}
            <div className="productos-background">
                <div className="productos-shape productos-shape-1"></div>
                <div className="productos-shape productos-shape-2"></div>
                <div className="productos-pattern"></div>
            </div>

            <Container className="productos-container">
                {/* Header */}
                <div className="productos-header text-center">
                    <div className="productos-badge">
                        <Sparkles size={20} />
                        <span>Novedades</span>
                    </div>
                    <h1 className="productos-title">
                        Productos <span className="text-highlight-productos">Nuevos</span>
                    </h1>
                    <p className="productos-subtitle">
                        Descubre nuestras últimas novedades con tecnología de punta
                    </p>
                    <div className="title-divider-productos"></div>
                </div>

                {/* Filtros de categorías */}
                <div className="productos-filtros">
                    {categorias.map((categoria) => (
                        <button
                            key={categoria.id}
                            className={`filtro-btn ${filtroCategoria === categoria.id ? 'active' : ''}`}
                            onClick={() => setFiltroCategoria(categoria.id)}
                        >
                            {categoria.nombre}
                        </button>
                    ))}
                </div>

                {/* Grid de productos */}
                <Row className="productos-grid g-4 mb-5">
                    {productosFiltrados.map((producto, index) => (
                        <Col 
                            key={producto.id}
                            xs={12}
                            sm={6}
                            lg={4}
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            <div 
                                className={`producto-card-nuevo ${producto.destacado ? 'destacado' : ''}`}
                                onClick={() => handleProductClick(producto)}
                            >
                                {/* Badges */}
                                <div className="producto-badges">
                                    {producto.nuevo && (
                                        <span className="badge-nuevo">
                                            <Sparkles size={14} />
                                            NUEVO
                                        </span>
                                    )}
                                    {producto.descuento && (
                                        <span className="badge-descuento">
                                            {producto.descuento}
                                        </span>
                                    )}
                                </div>

                                {/* Imagen principal */}
                                <div className="producto-imagen-container">
                                    <img 
                                        src={producto.imagenes[0]} 
                                        alt={producto.nombre}
                                        className="producto-imagen-principal"
                                    />
                                    
                                    {/* Overlay con opciones */}
                                    <div className="producto-overlay">
                                        <button 
                                            className="btn-imagen"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleProductClick(producto);
                                            }}
                                        >
                                            <span>Ver Galería</span>
                                        </button>
                                    </div>

                                    {/* Contador de imágenes */}
                                    <div className="imagen-counter">
                                        📷 {producto.imagenes.length}
                                    </div>

                                    {/* Indicador de video */}
                                    {producto.videos.length > 0 && (
                                        <div className="video-indicator">
                                            <Play size={20} fill="white" />
                                            {producto.videos.length}
                                        </div>
                                    )}
                                </div>

                                {/* Información del producto */}
                                <div className="producto-info-nuevo">
                                    <div className="marca-badge-nuevo">{producto.marca}</div>
                                    
                                    <h3 className="producto-nombre-nuevo">
                                        {producto.nombre}
                                    </h3>
                                    
                                    <p className="producto-descripcion">
                                        {producto.descripcion}
                                    </p>

                                    {/* Características rápidas */}
                                    {producto.caracteristicas.length > 0 && (
                                        <div className="caracteristicas-rapidas">
                                            {producto.caracteristicas.slice(0, 2).map((caract, idx) => (
                                                <span key={idx} className="caract-tag">
                                                    ✓ {caract}
                                                </span>
                                            ))}
                                        </div>
                                    )}

                                    {/* Footer del card */}
                                    <div className="producto-footer-nuevo">
                                        <span className="producto-precio-nuevo">{producto.precio}</span>
                                        
                                        <div className="producto-acciones">
                                            <button 
                                                className={`btn-accion ${favoritos.includes(producto.id) ? 'active' : ''}`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleFavorito(producto.id);
                                                }}
                                                title="Agregar a favoritos"
                                            >
                                                <Heart size={18} />
                                            </button>
                                            <button 
                                                className="btn-accion"
                                                title="Compartir"
                                            >
                                                <Share2 size={18} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>

                {/* Modal de producto */}
                <Modal 
                    show={showModal} 
                    onHide={() => setShowModal(false)}
                    size="xl"
                    className="productos-modal"
                    centered
                >
                    {selectedProduct && (
                        <>
                            <Modal.Header className="productos-modal-header">
                                <div className="modal-titulo-section">
                                    <span className="modal-marca">{selectedProduct.marca}</span>
                                    <h2>{selectedProduct.nombre}</h2>
                                </div>
                                <button 
                                    className="btn-close-modal"
                                    onClick={() => setShowModal(false)}
                                >
                                    <X size={24} />
                                </button>
                            </Modal.Header>

                            <Modal.Body className="productos-modal-body">
                                <Row className="g-4">
                                    {/* Galería de imágenes */}
                                    <Col lg={6}>
                                        <div className="galeria-container">
                                            {/* Imagen grande */}
                                            <div className="imagen-grande">
                                                <img 
                                                    src={selectedProduct.imagenes[currentImageIndex]} 
                                                    alt="Imagen del producto"
                                                />
                                                
                                                {/* Navegación */}
                                                {selectedProduct.imagenes.length > 1 && (
                                                    <>
                                                        <button 
                                                            className="nav-btn nav-btn-left"
                                                            onClick={prevImage}
                                                        >
                                                            <ChevronLeft size={24} />
                                                        </button>
                                                        <button 
                                                            className="nav-btn nav-btn-right"
                                                            onClick={nextImage}
                                                        >
                                                            <ChevronRight size={24} />
                                                        </button>
                                                    </>
                                                )}

                                                {/* Contador */}
                                                <div className="imagen-counter-grande">
                                                    {currentImageIndex + 1} / {selectedProduct.imagenes.length}
                                                </div>
                                            </div>

                                            {/* Miniaturas */}
                                            {selectedProduct.imagenes.length > 1 && (
                                                <div className="miniaturas">
                                                    {selectedProduct.imagenes.map((img, idx) => (
                                                        <div
                                                            key={idx}
                                                            className={`miniatura ${idx === currentImageIndex ? 'active' : ''}`}
                                                            onClick={() => setCurrentImageIndex(idx)}
                                                        >
                                                            <img src={img} alt={`Miniatura ${idx + 1}`} />
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </Col>

                                    {/* Información del producto y videos */}
                                    <Col lg={6}>
                                        <div className="info-productos-modal">
                                            {/* Precio y descuento */}
                                            <div className="precio-section">
                                                <span className="precio-grande">{selectedProduct.precio}</span>
                                                {selectedProduct.descuento && (
                                                    <span className="descuento-label">
                                                        Descuento: {selectedProduct.descuento}
                                                    </span>
                                                )}
                                            </div>

                                            {/* Descripción */}
                                            <p className="descripcion-modal">
                                                {selectedProduct.descripcion}
                                            </p>

                                            {/* Características */}
                                            <div className="caracteristicas-modal">
                                                <h4>Características</h4>
                                                {selectedProduct.caracteristicas.map((caract, idx) => (
                                                    <div key={idx} className="caract-item">
                                                        <Zap size={16} />
                                                        <span>{caract}</span>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Botones de acción */}
                                            <div className="acciones-modal">
                                                <button className="btn-favorito-modal">
                                                    <Heart size={20} />
                                                    Favorito
                                                </button>
                                                <button className="btn-compartir-modal">
                                                    <Share2 size={20} />
                                                    Compartir
                                                </button>
                                            </div>

                                            {/* Videos */}
                                            {selectedProduct.videos.length > 0 && (
                                                <div className="videos-section">
                                                    <h4>
                                                        <Play size={18} />
                                                        Videos
                                                    </h4>
                                                    {selectedProduct.videos.map((video, idx) => (
                                                        <div key={idx} className="video-item">
                                                            <div className="video-player">
                                                                <iframe
                                                                    width="100%"
                                                                    height="200"
                                                                    src={video.url}
                                                                    title={video.titulo}
                                                                    frameBorder="0"
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                    allowFullScreen
                                                                ></iframe>
                                                            </div>
                                                            <p className="video-titulo">{video.titulo}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {/* CTA */}
                                            <button className="btn-cotizar-modal">
                                                <Award size={20} />
                                                Solicitar Información
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </Modal.Body>
                        </>
                    )}
                </Modal>
            </Container>
        </section>
    );
}

export default ProductosNuevos;